import { createAction, props } from "@ngrx/store";

const module = "Global";
const subModule = "Layout";
const combinedModule = `[${module}] [${subModule}]`;

export const setToolBarActive = createAction(`${combinedModule} Set toolbar active`, props<{ active: boolean }>());
